<div class="ads-settings-component-container page-root-container">
    <div class="page-header">
        <div class="page-title">
            <img class="icon" src="assets/images/menu/svg/ads-settings.svg"><span class="title">Ads Settings</span>
        </div>
        <div class="page-actions">
            @if(permission?.can_add){
            <button mat-button color="primary" class="btn-add" (click)="addClicked()">
                <mat-icon>add</mat-icon>New
            </button>
            }
        </div>
    </div>

    <div class="data-container">
        <app-loader [show]="isLoading"></app-loader>

        <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
            [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true"
            [enableCustFilter]="true">
        </app-search-filter>

        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)">
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef (click)="sortData($event)" class="item-header">#</th>
                    <td mat-cell *matCellDef="let ad; let i = index" class="item-column">
                        {{ (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="title">
                    <th mat-sort-header="title" mat-header-cell *matHeaderCellDef (click)="sortData($event)">Title</th>
                    <td mat-cell *matCellDef="let ad"> {{ad.title}} </td>
                </ng-container>

                <ng-container matColumnDef="media_type">
                    <th mat-sort-header="media_type" mat-header-cell *matHeaderCellDef (click)="sortData($event)">Media
                        Type</th>
                    <td mat-cell *matCellDef="let ad" style="text-transform: capitalize;"> {{ad.media_type == 1 ?
                        'Image' : 'Video'}} </td>
                </ng-container>

                <ng-container matColumnDef="period_from">
                    <th mat-sort-header="period_from" mat-header-cell *matHeaderCellDef (click)="sortData($event)">Start
                        Date</th>
                    <td mat-cell *matCellDef="let ad"> {{ad.period_from | date:'dd-MM-yyyy'}} </td>
                </ng-container>

                <ng-container matColumnDef="period_to">
                    <th mat-sort-header="period_to" mat-header-cell *matHeaderCellDef (click)="sortData($event)">End
                        Date</th>
                    <td mat-cell *matCellDef="let ad"> {{ad.period_to | date:'dd-MM-yyyy'}} </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class="status-header">Status</th>
                    <td mat-cell *matCellDef="let ad" class="status-column">
                        <span [ngClass]="{'active': ad.is_active == 1, 'unpublished': ad.is_active == 0}"
                            class="status">
                            {{ ad.is_active == 1 ? 'Active' : 'Inactive' }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let rowItem">
                        <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
                            (click)="onRowSelected(rowItem);$event.stopPropagation();">
                            <mat-icon>more_vert</mat-icon>
                        </a>

                        <mat-menu #rowMenu>
                            <button mat-menu-item (click)="onDelete(rowItem)">Delete</button>
                            <button mat-menu-item (click)="onEdit(rowItem)">Edit</button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row class="table-element-row" *matRowDef="let ad; columns: displayedColumns;"
                    (click)="onRowSelected(ad)" (dblclick)="onEdit(ad)"
                    [ngClass]=" {'row-selected' : ad.id===selectedItem?.id}">
                </tr>
            </table>
        </section>

        @if(pagingData.length<=0){ <div class="no-data-container">
            <img src="assets/images/no-data.png">
            <span class="no-data-info">No data found. Please remove or redefine the filters if any.</span>
    </div>
    }
</div>
</div>